import * as Yup from 'yup';

import { passwordRegex } from '../../constants';

export const changePasswordYupValidation = () => {
  return Yup.object().shape({
    password: Yup.string().required('required').min(15, 'min15').matches(passwordRegex, 'passwordPattern'),
    repeatPassword: Yup.string()
      .required('required')
      .oneOf([Yup.ref('password')], 'passwordNotMatch'),
  });
};

export const changeUserPasswordYupValidation = () => {
  return Yup.object().shape({
    oldPassword: Yup.string().required('required'),
    password: Yup.string().required('required').min(15, 'min15').matches(passwordRegex, 'passwordPattern'),
    repeatPassword: Yup.string()
      .required('required')
      .oneOf([Yup.ref('password')], 'passwordNotMatch'),
  });
};
